import axios from 'axios'
import { config, url } from '../../../index'

const state = () => ({
  tableHeaders: [
    {
      title: 'Название',
      isSortable: false
    }
  ],
  schedules: [],
  isLoading: true,
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  updateModal: {
    active: false,
    schedule: {},
    validation: {}
  },
  createModal: {
    active: false,
    newScheduleName: '',
    validation: {}
  }
})

const getters = {
  schedules: state => state.schedules,
  scheduleListIsLoading: state => state.isLoading,
  scheduleListTableHeaders: state => state.tableHeaders,
  scheduleListUpdateModal: state => state.updateModal,
  scheduleListCreateModal: state => state.createModal
}

const mutations = {
  // получение списка всех видов занятости
  GET_SCHEDULES: (state, schedules) => {
    // добавляем к каждому объекту свойство для отрисовки состояния меню (ред./удалить)
    state.schedules = schedules.map(schedule => {
      return {
        ...schedule,
        isControlsActive: false
      }
    })
    // убираем флаг "контент загружается"
    state.isLoading = false
  },
  // вкл/выкл меню (редактировать/удалить)
  SCHEDULE_LIST_TOGGLE_CONTROLS: (state, itemId) => {
    state.schedules.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  // выкл меню (редактировать/удалить) при клике вне элемента
  CLOSE_SCHEDULE_LIST_CONTROLS: (state) => {
    state.schedules.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  // показ модалки для редактирования записи
  SHOW_SCHEDULE_LIST_UPDATE_MODAL: (state, scheduleId) => {
    state.updateModal.active = true
    // помещаем в модалку копию объекта чтобы редактирование не затрагивало таблицу
    const copies = state.schedules.map(schedule => ({ ...schedule }))
    state.updateModal.schedule = copies.filter(schedule => {
      return schedule.id === scheduleId
    }).shift()
  },
  SET_UPDATED_SCHEDULE_NAME: (state, name) => {
    state.updateModal.schedule.name = name
  },
  SHOW_SCHEDULE_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  SET_CREATED_SCHEDULE_NAME: (state, name) => {
    state.createModal.newScheduleName = name
  },
  // закрытие всех модалок
  CLOSE_SCHEDULE_LIST_MODALS: (state) => {
    // модалка редактирвоания
    state.updateModal.active = false
    state.updateModal.schedule = {}
    // модалка создания
    state.createModal.active = false
    state.createModal.newScheduleName = ''
  },
  SET_SCHEDULE_LIST_MODAL_VALIDATION: (state, validationData) => {
    switch (validationData.modal) {
      case 'create':
        state.createModal.validation = validationData.validation
        break
      case 'update':
        state.updateModal.validation = validationData.validation
        break
      default:
        state.createModal.validation = {}
        state.updateModal.validation = {}
    }
  },
  // записть в стейт состояния пагинации
  SET_SCHEDULE_LIST_PAGINATION: (state, paginationData) => {
    state.pagination.currentPage = paginationData.current_page
    state.pagination.lastPage = paginationData.last_page
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(paginationData.last_page).keys()].map(i => ++i)
  },
  TOGGLE_SCHEDULE_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = !state.pagination.pageList.active
  },
  CLOSE_SCHEDULE_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = false
  }
}

const actions = {
  getSchedules ({ state, commit }) {
    axios.get(`${url}/schedules?per-page=1`, config).then(response => {
      axios.get(`${url}/schedules?sort=-id&per-page=${response.headers['x-pagination-total-count']}`, config).then(response => {
        commit('GET_SCHEDULES', response.data.data)
      })
    }).catch(error => {
      console.log('ошибка получения списка графиков', error.response ? error.response : error)
    })
  },
  // раскомментить и отредактировать когда будет пагинация
  /* getPositionListPrevPage ({ state, commit }) {
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage - 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListNextPage ({ state, commit }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage + 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListPage ({ state, commit }, pageNum) {
    const currentTake = state.pagination.currentTake
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${pageNum}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
    })
  },
  togglePositionListPageList ({ commit }) {
    commit('TOGGLE_POSITION_LIST_PAGE_LIST')
  }, */
  // переключение всплывающих меню (ред./удалить)
  toggleScheduleListItemControls ({ commit }, itemId) {
    commit('SCHEDULE_LIST_TOGGLE_CONTROLS', itemId)
  },
  // показ модалки редактирования записи
  showScheduleListUpdateModal ({ commit }, scheduleId) {
    commit('SHOW_SCHEDULE_LIST_UPDATE_MODAL', scheduleId)
  },
  // редактирование имени записи
  setUpdatedScheduleName ({ commit }, name) {
    commit('SET_UPDATED_SCHEDULE_NAME', name)
  },
  // показ модалки создания записи
  showScheduleListCreateModal ({ commit }) {
    commit('SHOW_SCHEDULE_LIST_CREATE_MODAL')
  },
  // редактирование имени новой записи
  setCreatedScheduleName ({ commit }, name) {
    commit('SET_CREATED_SCHEDULE_NAME', name)
  },
  // закрытие всех модалок
  closeScheduleListModals ({ commit }) {
    commit('CLOSE_SCHEDULE_LIST_MODALS')
    // закрываем все всплывашки (ред./удалить)
    commit('CLOSE_SCHEDULE_LIST_CONTROLS')
  },
  // создание записи
  createSchedule ({ commit, state }) {
    if (state.createModal.newScheduleName) {
      const postData = {
        name: state.createModal.newScheduleName
      }

      axios.post(`${url}/schedules`, postData, config).then(response => {
        this.dispatch('getSchedules')
        this.dispatch('closeScheduleListModals')
      }).catch(error => {
        console.log('Ошибка создания графика работы:' + error)
      })
    } else {
      commit('SET_SCHEDULE_LIST_MODAL_VALIDATION', { modal: 'create', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // редактирование записи
  updateSchedule ({ commit, state }) {
    if (state.updateModal.schedule.name) {
      const scheduleData = {
        id: state.updateModal.schedule.id,
        name: state.updateModal.schedule.name
      }

      axios.put(`${url}/schedules/${scheduleData.id}`, scheduleData, config).then(response => {
        this.dispatch('getSchedules')
        this.dispatch('closeScheduleListModals')
      }).catch(error => {
        console.log('Ошибка редактирования графика работы:' + error)
      })
    } else {
      commit('SET_SCHEDULE_LIST_MODAL_VALIDATION', { modal: 'update', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // очищаем поля валидации
  clearScheduleListModalValidation ({ commit }) {
    commit('SET_SCHEDULE_LIST_MODAL_VALIDATION', { modal: null, validation: null })
  },
  // удаление записи
  deleteSchedule ({ commit }, scheduleId) {
    axios.delete(`${url}/schedules/${scheduleId}`, config).then(response => {
      console.log('График работы успешно удален')
      this.dispatch('getSchedules')
      this.dispatch('closeScheduleListModals')
    }).catch(error => {
      console.log('Ошибка удаления графика работы' + error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
